export default __webpack_public_path__ + "static/media/Principal2.b2a34883.jpeg";